// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file documents/v3alpha/comments.proto (package com.seed.documents.v3alpha, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BatchGetCommentsRequest, BatchGetCommentsResponse, Comment, CreateCommentRequest, DeleteCommentRequest, GetCommentReplyCountRequest, GetCommentReplyCountResponse, GetCommentRequest, ListCommentsByAuthorRequest, ListCommentsRequest, ListCommentsResponse, ListCommentVersionsRequest, ListCommentVersionsResponse, UpdateCommentRequest } from "./comments_pb";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * Comments service allows users to add comments to documents.
 *
 * @generated from service com.seed.documents.v3alpha.Comments
 */
export const Comments = {
  typeName: "com.seed.documents.v3alpha.Comments",
  methods: {
    /**
     * Creates a new comment.
     *
     * @generated from rpc com.seed.documents.v3alpha.Comments.CreateComment
     */
    createComment: {
      name: "CreateComment",
      I: CreateCommentRequest,
      O: Comment,
      kind: MethodKind.Unary,
    },
    /**
     * Gets a single comment by ID.
     *
     * @generated from rpc com.seed.documents.v3alpha.Comments.GetComment
     */
    getComment: {
      name: "GetComment",
      I: GetCommentRequest,
      O: Comment,
      kind: MethodKind.Unary,
    },
    /**
     * Get multiple comments by ID.
     *
     * @generated from rpc com.seed.documents.v3alpha.Comments.BatchGetComments
     */
    batchGetComments: {
      name: "BatchGetComments",
      I: BatchGetCommentsRequest,
      O: BatchGetCommentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists comments for a given target.
     *
     * @generated from rpc com.seed.documents.v3alpha.Comments.ListComments
     */
    listComments: {
      name: "ListComments",
      I: ListCommentsRequest,
      O: ListCommentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists comments by author.
     *
     * @generated from rpc com.seed.documents.v3alpha.Comments.ListCommentsByAuthor
     */
    listCommentsByAuthor: {
      name: "ListCommentsByAuthor",
      I: ListCommentsByAuthorRequest,
      O: ListCommentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates an existing comment.
     *
     * @generated from rpc com.seed.documents.v3alpha.Comments.UpdateComment
     */
    updateComment: {
      name: "UpdateComment",
      I: UpdateCommentRequest,
      O: Comment,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a comment.
     *
     * @generated from rpc com.seed.documents.v3alpha.Comments.DeleteComment
     */
    deleteComment: {
      name: "DeleteComment",
      I: DeleteCommentRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Gets a single comment by ID.
     *
     * @generated from rpc com.seed.documents.v3alpha.Comments.GetCommentReplyCount
     */
    getCommentReplyCount: {
      name: "GetCommentReplyCount",
      I: GetCommentReplyCountRequest,
      O: GetCommentReplyCountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists all versions of a comment (edit history).
     *
     * @generated from rpc com.seed.documents.v3alpha.Comments.ListCommentVersions
     */
    listCommentVersions: {
      name: "ListCommentVersions",
      I: ListCommentVersionsRequest,
      O: ListCommentVersionsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

